import { get, post, deleteApi } from './request'

function getVipAccount(data) {
  return get('/channel_admin/vip_account', data)
}

// 根据vip类型和vip等级查看vip配置
function getVipConfig(params) {
  return get('/channel_admin/vip_config', params)
}

// 保存vip配置
function postVipConfig(data) {
  return post('/channel_admin/vip_config', data)
}
// 获取套餐详细信息
function getPackageConfig(data) {
  return get('/channel_admin/package', data)
}

// 获取所有vip样式列表
function getVipStyleList() {
  return get('/channel_admin/vip/level_imgs')
}

// 获取所有vip类型和vip等级的组合信息
function getVipConfigList() {
  return get('/channel_admin/vip_config/list')
}

// 删除vip等级
function deleteVipConfig(params) {
  return deleteApi('/channel_admin/vip_config', params)
}

export { getVipAccount, getVipConfig, postVipConfig, getPackageConfig, getVipStyleList, getVipConfigList, deleteVipConfig }
